/* eslint-disable import/prefer-default-export */
const a11yProps = index => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
};

export { a11yProps };
